"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.delete.confirm': 'Usuń Poradnik',
    'tutorial.delete.confirmText': 'Czy na pewno chcesz usunąć ten poradnik? Tej operacji nie można cofnąć.',
    'tutorial.delete.success': 'Poradnik został pomyślnie usunięty',
};
